import { AxiosPromise, CancelToken } from 'axios';
import {
    ContactMessageChannelRequest,
    ContactMessageChannelStats,
} from '../sic-lib/types/ContactMessageChannelStats';
import { apiInstance as instance } from './';

let requestChannelItems_cancel: any;
/**
 * requestChannelItems
 *
 * @description
 * Makes a HTTP request to retrieve the a set of stats for the dashboard
 */
export function requestContactMessageChannelStats(
    data: ContactMessageChannelRequest,
    cancelToken: CancelToken,
): AxiosPromise<ContactMessageChannelStats> {
    if (requestChannelItems_cancel) requestChannelItems_cancel();

    return instance.post(`/dashboard/report`, data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
